import { Paper } from "@mui/material";
// import { useEffect } from "react";
import CommentBox from "../patient/CommentBox"
import { formatDisc } from "./codeHelper";
// import { Rating } from 'react-simple-star-rating'; 
// import { useState } from "react";

export default function Feedback(props) {

    return (
        <div>
            <div>
                <Paper elevation={3} className="p-4 ">
                    <div className="mt-4">
                        <div className="font-semibold mb-2">Feedback
                            {
                                props.diskCode &&
                                <span> {formatDisc(props.diskCode)}</span>
                            }
                        </div>
                        <CommentBox diskCode={props.diskCode} type={props.type} msg={props.msg}/>
                    </div>
                </Paper>
            </div>
        </div>
    )
}